<template>
  <div
    role="dialog"
    class="max-sm:h-full w-[468px] flex justify-center items-center h-full flex-col bg-white max-lg:rounded-t-3xl lg:rounded-2xl p-6"
  >
    <div class="pb-4 w-full">
      <slot name="header" />
    </div>
    <div class="overflow-y-auto max-h-[40vh] min-h-0 pb-4 w-full">
      <slot name="body" />
    </div>
    <div
      class="flex-shrink-0 w-full mt-auto bg-white pt-6 border-t border-[#BABABA52]"
    >
      <slot name="footer" />
    </div>
  </div>
</template>
